import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { restoreBookingSession } from "app/pages/Booking/Quotation/quotationActionCreators";
import PaymentContainer from "app/pages/Booking/Payment/PaymentContainer";
import { useEffect, useState } from "react";
import Loader from "app/pages/.shared/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import { parseQueries } from "app/utils/routerUtils";
import isEmpty from "lodash/isEmpty";
import { HTTP_STATUS_CODES, RESTORE_SESSION_STATUS } from "app/constants";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

const RestoreSessionContainer = props => {
	const [isLoading, setLoading] = useState(true);

	const { search } = useLocation();

	const { track } = useAnalytics();

	const navigate = useNavigate();

	const { bookingReference, email } = parseQueries(search);

	const { restoreBookingSession } = props;

	useEffect(() => {
		setLoading(true);
		if (email && bookingReference) {
			restoreBookingSession({ bookingReference, email }).then(response => {
				setLoading(false);

				const responseStatusCode = response.status;

				switch (responseStatusCode) {
					case HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR: {
						navigate({
							pathname: "/technical-error",
						});

						track("restore-session-error", {
							httpStatusCode: responseStatusCode,
						});

						break;
					}
					case HTTP_STATUS_CODES.OK: {
						const responseStatus = response.data?.status;

						if (responseStatus === RESTORE_SESSION_STATUS.BAD_REQUEST) {
							const responseMessage = response.data?.message;

							navigate(
								{
									pathname: "/technical-error",
								},
								{
									state: { errorMessage: responseMessage },
								}
							);

							track("restore-session-error", {
								httpStatusCode: HTTP_STATUS_CODES.OK,
								status: RESTORE_SESSION_STATUS.BAD_REQUEST,
								errorMessage: responseMessage,
							});

							break;
						} else {
							const bookResponse = response.data?.bookResponse || {};
							const bookRequest = response.data?.bookRequest || {};
							const preBookResponse = response.data?.preBookResponse || {};

							const insurance = preBookResponse?.insurances?.insurancesItem?.find(
								insurance => insurance.code === bookRequest?.insurance
							);

							if (!isEmpty(bookResponse)) {
								navigate(
									{
										pathname: "../confirmation",
									},
									{
										state: {
											bookingReference: bookResponse?.bookingReference,
											status: bookResponse?.status,
											email: bookRequest?.customer?.email,
											insuranceName: insurance?.name,
											paymentMode: bookRequest?.payment?.terms,
											paymentType: bookRequest?.payment?.type,
											// total,
										},
									}
								);
							}

							break;
						}
					}

					default: {
						navigate({
							pathname: "/technical-error",
						});

						track("restore-session-error", {
							httpStatusCode: responseStatusCode,
						});

						break;
					}
				}
			});
		} else {
			setLoading(false);
		}
	}, [bookingReference, email]);

	return isLoading ? (
		<div style={{ textAlign: "center" }}>
			<Loader />
		</div>
	) : (
		// ajouter disableFetchProfile={true} ici quand PaymentContainer sera sous formik
		// en attendant disableFetchProfile sera valorisé dans PaymentContainer
		<PaymentContainer {...props} />
	);
};

RestoreSessionContainer.propTypes = {
	restoreBookingSession: PropTypes.func,
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			restoreBookingSession,
		},
		dispatch
	);
};

export default connect(
	null,
	mapDispatchToProps
)(RestoreSessionContainer);
